module.exports = __webpack_public_path__ + "img/hy5.3af159ec.png";